var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCode = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50687 0.218929C9.93818 0.314775 10.2101 0.742116 10.1143 1.17342L7.44761 13.1734C7.35176 13.6047 6.92442 13.8767 6.49311 13.7808C6.06181 13.685 5.78986 13.2576 5.88571 12.8263L8.55237 0.826334C8.64822 0.395027 9.07556 0.123083 9.50687 0.218929ZM5.23234 3.10086C5.54476 3.41328 5.54476 3.91981 5.23234 4.23223L2.4647 6.99988L5.23234 9.76753C5.54476 10.0799 5.54476 10.5865 5.23234 10.8989C4.91992 11.2113 4.41339 11.2113 4.10097 10.8989L0.76764 7.56556C0.45522 7.25314 0.45522 6.74661 0.76764 6.43419L4.10097 3.10086C4.41339 2.78844 4.91992 2.78844 5.23234 3.10086ZM10.7676 3.10086C11.0801 2.78844 11.5866 2.78844 11.899 3.10086L15.2323 6.43419C15.5448 6.74661 15.5448 7.25314 15.2323 7.56556L11.899 10.8989C11.5866 11.2113 11.0801 11.2113 10.7676 10.8989C10.4552 10.5865 10.4552 10.0799 10.7676 9.76753L13.5353 6.99988L10.7676 4.23223C10.4552 3.91981 10.4552 3.41328 10.7676 3.10086Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Code.29170856a0a98f9e5e87892876153aba.svg";